import VueRouter from 'vue-router';
import { /*reloadIfNotFound,*/
  hideAllModal,
  setAuthAndPtid,
  updateTitle,
  routechange
} from './hooks';

/* global HLCX_H5_BASE_URL */
const base = HLCX_H5_BASE_URL.replace(/^https?:\/\/[^\/]+/, '');

const router = new VueRouter({
  mode: 'history',
  base: base,
  routes: [],
  // FIXME: 给router设置scrollBehavior会导致刷新页面时router会重置当前页面的state，然后后一页的动画就反了
  scrollBehavior
});

// authorize在auth里定义和使用
//router.beforeEach(reloadIfNotFound);
router.beforeEach(hideAllModal);
router.beforeEach(setAuthAndPtid);
router.afterEach(updateTitle);
router.afterEach(routechange);

export default router;

function scrollBehavior(to, from, savedPosition) {
  // NOTE: 如果路由切换的动画改变了要进入的页面容器的高度，那么此处需要返回异步，或者在动画里滚动
  if (savedPosition) {
    return savedPosition;
  } else {
    return {
      x: 0,
      y: 0
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/router/index.js